import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useDataTableContext } from "@msuite/ui/table";
import { Fragment } from "@msuite/ui/utils";
import { Can } from "@/components/citadel/can";
import { AddWarehouseLocationsModal } from "@/modals/stock/add-warehouse-locations-modal";
import { AddWarehouseZoneModal } from "@/modals/stock/add-warehouse-zone-modal";

export function WarehouseZonesMenu() {
	/** Context */
	const { refetch } = useDataTableContext();

	/** Hooks */
	const { t } = useTranslation();
	const addWarehouseZoneModal = useDisclosure();
	const addWarehouseLocationsModal = useDisclosure();

	/** Render */
	return (
		<Fragment>
			<div className="h-stack gap-4">
				<Can
					action="create"
					subject="Stock"
				>
					<Button
						variant="primary"
						icon={<Icon name="Plus" />}
						onClick={addWarehouseZoneModal.onOpen}
					>
						{t("stock.add_warehouse_zone")}
					</Button>
				</Can>
				{/* The cog sets the warehouse's shelf/axis/floor dimensions, which is `update`. */}
				<Can
					action="update"
					subject="Stock"
				>
					<Button
						icon={<Icon name="Cog" />}
						onClick={addWarehouseLocationsModal.onOpen}
					/>
				</Can>
			</div>
			{addWarehouseZoneModal.isOpen && (
				<AddWarehouseZoneModal
					isOpen={addWarehouseZoneModal.isOpen}
					onClose={addWarehouseZoneModal.onClose}
					onComplete={refetch}
				/>
			)}
			{addWarehouseLocationsModal.isOpen && (
				<AddWarehouseLocationsModal
					isOpen={addWarehouseLocationsModal.isOpen}
					onClose={addWarehouseLocationsModal.onClose}
				/>
			)}
		</Fragment>
	);
}
